import { useRouteLoaderData } from 'react-router';
import { VoiceSubscriptionRingSettings } from '../../../../../components/SubscriptionDetails/VoiceSubscriptionRingSettings.js';
import { VoiceSubscriptionLayout } from '../../../../../components/SubscriptionLayout/VoiceSubscriptionLayout.js';
import type { MobileSubscriptionLoaderResponse } from '../../../../../common/loaders.js';

export const VoiceSubRingSettingsPath = () => {
  const { addOnRules, addOnRulesMobilePbx, companyInfo, contacts, hasPendingActions, ringModel, subscription } =
    useRouteLoaderData('voiceSub') as MobileSubscriptionLoaderResponse;

  return (
    <VoiceSubscriptionLayout
      addOnRules={addOnRules}
      addOnRulesMobilePbx={addOnRulesMobilePbx}
      contacts={contacts}
      companyInfo={companyInfo}
      subscription={subscription}
    >
      <VoiceSubscriptionRingSettings
        subscription={subscription}
        hasPendingActions={hasPendingActions}
        companyInfo={companyInfo}
        contacts={contacts}
        ringModel={ringModel!}
        addOnRules={addOnRules}
        addOnRulesMobilePbx={addOnRulesMobilePbx}
      />
    </VoiceSubscriptionLayout>
  );
};
